/**
 * Kelley SD - Supabase Browser Client
 *
 * Client-side Supabase instance for use in React components.
 * Uses the public anon key (safe for browser exposure).
 *
 * @version 1.0.0 - Spec 014 Layer 1, Spec B
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'] as string | undefined;
const supabaseAnonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined;

/**
 * Singleton Supabase client for browser-side usage.
 *
 * - Uses the public anon key (row-level security enforced server-side)
 * - Automatically manages auth sessions via cookies
 * - Safe to import from any React component or client-side module
 * - Returns null if env vars are missing (non-auth pages still work)
 */
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;

if (!supabase) {
  console.warn(
    '[supabase-browser] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Auth features will be unavailable.'
  );
}
